/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_TitleInputs */

const fr_membership_freeze_title = /** @type {(inputs: Membership_Freeze_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre mon abonnement en pause`)
};

/**

* @param {Membership_Freeze_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_title = /** @type {((inputs?: Membership_Freeze_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_title(inputs)
});